import { HttpContextToken, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { fromPromise } from 'rxjs/internal/observable/innerFrom';
import { lastValueFrom } from 'rxjs';

export const NO_AUTH = new HttpContextToken(() => false);

const handle = async (req: HttpRequest<unknown>, next: HttpHandlerFn, token: string) => {
  try {
    const authorizedRequest = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });

    return await lastValueFrom(next(authorizedRequest));
  } catch (e) {
    console.error('Error occurred!', e);
    return await lastValueFrom(next(req));
  }
};

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(NO_AUTH)) {
    return next(req);
  }

  // return fromPromise(inject(AccessTokenService).get()).pipe(switchMap((value) => fromPromise(handle(req, next, value))));
  return fromPromise(
    handle(
      req,
      next,
      // todo: propper authentication instead of hardcoding a secret
      'eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1c2VyX2d0IiwidHlwZSI6IkFDQ0VTUyIsImV4cCI6MTc5MjU2OTcwMX0.gzOSO6VkNoGb6VgLTAftcIOFxHYrF05PcwnITiNISiY', // gitleaks:allow
    ),
  );
};
